import { useEffect, useState } from "react";
import CardCliente from "../../components/helpers/CardCliente";
import LoaderC from "../../components/helpers/LoaderC";
import Tabs from "rsuite/Tabs";
import 'rsuite/Tabs/styles/index.css';
import RegistrarPago from "../contratos/componentes/RegistrarPago";
import 'rsuite/Placeholder/styles/index.css';
import { axiosInstance } from "../../components/helpers/axiosInstance";
import { useContratos } from "../../components/contratos/ContratosProvider";

/**
 * @function conceptoText : texto completo de historico
 * @param clave
 * @returns {*|string}
 */
export function conceptoText(clave){
    switch (clave){
        case '1A' :
            return "1 año";
        case '4A' :
            return "4 años";
        case '6A' :
            return "6 años";
        case '10A' :
            return "10 años";
        case 'TT' :
            return "Total";
        default :
            return clave;
    }
}

/**
 * @function PerfilCliente : componente principal
 * @param clienteId
 * @param contratoId
 * @returns {JSX.Element}
 * @constructor
 */
export default function PerfilCliente({
  contratoId,
  clienteId
}) {
    /**
     * Guardar contrato seleccionado
     */
    const [contrato, setContrato] = useState(null);
    /**
     * Guardar el IVA cálculado ( se hace para todos los contratos )
     */
    const [iva, setIva] = useState(0);
    /**
     * Guardar total + iva de contrato ( se hace para todos los contratos )
     */
    const [totalIva, setTotalIva] = useState(0);

    const { contratos } = useContratos();
    /**
     * Cálculos del contrato seleccionado, se ejecuta cada que cambia el id_contrato
     */
    useEffect(() => {

        axiosInstance.get(`/clientes/${clienteId}/contratos/${contratoId}`)
            .then((response) => {
                /**
                 * Guardar el contrato en un estado
                 */
                setContrato(response.data[0]);
                /**
                 * Cálcular IVA y guardarlo en un estado
                 * @type {number}
                 */
                const total = Number(response.data[0].costo_paquete) + Number(response.data[0].costo_addons);
                const ivaCal = total * 0.16;
                setIva(ivaCal);
                /**
                 * Sumar IVA al total y guardarlo en un estado
                 */
                const totalIvaCal = total + ivaCal;
                setTotalIva(totalIvaCal);

            }).catch((error) => {
                console.log(error);
        })


    }, [clienteId, contratoId, contratos]);

    return (
        <>
            <style type={'text/css'}>
                {`
                    .nav-underline .nav-link.active, .nav-underline .show > .nav-link {
                        border-bottom-color: var(--bs-primary);
                        border-bottom-width: 2px;
                    }
                    
                    .rs-nav-item{
                        border : 0!important;
                    }
                    
                    .rs-nav-item.rs-nav-item-active{
                        color : var(--bs-primary)!important;
                    }
                    
                    .rs-nav-subtle .rs-nav-item.rs-nav-item-active::before{
                        background-color : var(--bs-primary)!important;
                    }
                    
                    .rs-nav-subtle .rs-nav-item:hover, .rs-nav-subtle .rs-nav-item:focus{
                        color : var(--bs-primary)!important;
                    }
                    
                    .rs-nav-item{
                        color : var(--bs-gray-500)!important;
                        font-size : 1.1rem!important;
                        font-weight : 600!important;
                        line-height :  var(--bs-body-line-height)!important;
                        padding-top : 1.25rem!important;
                        padding-bottom : 1.25rem!important;
                    }
                    
                    .rs-nav-horizontal{
                        overflow-y : auto;
                    }
                    
                    // .rs-nav-vertical .rs-nav-bar{
                    //     display : none!important;
                    // }
                    //
                    // .rs-nav-subtle.rs-nav-vertical .rs-nav-item.rs-nav-item-active::before{
                    //     bottom : 0!important;
                    //     left : 0!important;
                    //     right : 0!important;
                    //     height : 2px!important;
                    //     top : unset !important;
                    //     width : auto!important;
                    // }
                    
                    .capitalize-first {
                        text-transform: lowercase;
                        display: block;
                    }
                    
                    .capitalize-first::first-letter {
                        text-transform: uppercase;
                    }
                    
                `}
            </style>
            {
                contrato !== null ? (
                    <>
                        <div className="card card-bordered my-2 mb-xl-5 rounded-bottom-0">
                            <div className="card-body pt-0 pb-0">
                                <CardCliente contrato={contrato}></CardCliente>
                                <div className="separator"></div>
                                <Tabs defaultActiveKey="contratacion" appearance="subtle">
                                    <Tabs.Tab eventKey="contratacion" title="Contratación"
                                      icon={<i
                                        className="ki-duotone ki-document text-primary">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                        </i>}
                                    >
                                        <div className={"card card-bordered mb-4"}>
                                            <div className="card-body">
                                                <div className="flex-grow-1 mx-5">
                                                    <div className="d-flex justify-content-between flex-wrap gap-5 bg-gray-100 border-bottom border-gray-200 py-2 ">
                                                        <div className="ms-2">
                                                            <button className="btn btn-sm btn-info fw-normal me-3 d-flex d-none">
                                                                <i className="ki-solid ki-arrows-circle fs-6"></i>
                                                                <span className={"d-none d-md-flex"}>Actualizar</span>
                                                            </button>
                                                        </div>
                                                        <div className="d-flex align-items-center me-1">
                                                            <button className="d-flex btn btn-sm btn-success fw-normal me-3 d-none">
                                                                <i className="bi bi-puzzle-fill fs-3"></i>
                                                                <span className={"d-none d-md-flex"}>A&ntilde;adir Complemento</span>
                                                            </button>
                                                            <button className="d-flex btn btn-sm btn-danger fw-normal me-3 d-none">
                                                                <i className="bi bi-box2-fill fs-5"></i>
                                                                <span className={"d-none d-md-flex"}>
                                                                    Cambiar Paquete
                                                                </span>
                                                            </button>
                                                            <RegistrarPago contrato={contrato} typeB={false}></RegistrarPago>
                                                        </div>
                                                    </div>
                                                    <div className={"mb-5"}>
                                                        <div className={"d-flex fw-bold text-gray-700 fs-5 py-3 justify-content-between"}>
                                                            <div className={"d-flex align-items-center"}>
                                                                <i className="fa fa-genderless text-danger fs-2 me-2"></i>
                                                                 <span className={"capitalize-first"}>{contrato.paquete.paquete ? (contrato.paquete.paquete) : ('SIN PAQUETE')}</span>
                                                            </div>
                                                            <div className="text-gray-900 fw-bolder">$ {contrato.costo_paquete}.00</div>
                                                        </div>
                                                        {
                                                            (contrato.paquete && contrato.paquete.conceptos) && contrato.paquete.conceptos.map((c) => {
                                                                return(
                                                                    <div key={c.clave} className="text-gray-700 fs-5 text-end">
                                                                        <div className="d-flex align-items-center py-1 ps-6">
                                                                            <i className="ki ki-solid ki-check text-success fs-2 me-2"></i>
                                                                            <span className={"capitalize-first fw-bolder"}>{c.concepto}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                        <div className="d-flex justify-content-between fw-bold text-gray-700 fs-5 text-end py-3">
                                                            <div className="d-flex align-items-center">
                                                                <i className="fa fa-genderless text-primary fs-2 me-2"></i>
                                                                Complementos
                                                            </div>
                                                            <div className="py-1 text-gray-900 fw-bolder">$ {contrato.addons ? contrato.addons.costo : '00'}.00</div>
                                                        </div>
                                                        {
                                                            (contrato.addons && contrato.addons.conceptos) && contrato.addons.conceptos.map((c) => {
                                                                return(
                                                                    <>
                                                                        <div key={c.id} className="d-flex text-gray-700 fs-5 justify-content-between">
                                                                            <div className="d-flex align-items-center py-1 ps-7">
                                                                                <i className="bi bi-puzzle-fill text-success fs-3 me-2"></i>
                                                                                <span className={"capitalize-first fw-bolder"}>{c.concepto}</span>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-9 bg-gray-200 rounded-4 p-5 ">
                                                            <div className="fw-semibold text-gray-800 fs-7 ">
                                                                Motivo Descuento:
                                                            </div>
                                                            <div className="text-gray-700 fs-7 px-4 py-2">
                                                                {
                                                                    contrato.observaciones && <span>{contrato.observaciones}</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="d-flex">
                                                                <div className="w-100">
                                                                    <div className="d-flex flex-stack mb-3 justify-content-between">
                                                                        <div className="fw-semibold text-gray-600 fs-7">Descuento:</div>
                                                                        <div className="text-end fw-bold fs-6 text-gray-800">$ { contrato.descuento }.00</div>
                                                                    </div>
                                                                    <div className="d-flex flex-stack mb-3 justify-content-between">
                                                                        <div className="fw-semibold text-gray-600 fs-7">Total sin IVA:</div>
                                                                        <div className="text-end fw-bold fs-6 text-gray-800">$ { Number(contrato.costo_paquete) + Number(contrato.costo_addons) }.00</div>
                                                                    </div>
                                                                    <div className="d-flex flex-stack mb-3 justify-content-between">
                                                                        <div className="fw-semibold text-gray-600 fs-7">IVA:</div>
                                                                        <div className="text-end fw-bold fs-6 text-gray-800">$ {iva}.00</div>
                                                                    </div>
                                                                    <div className="d-flex flex-stack justify-content-between">
                                                                        <div className="fw-semibold text-gray-600 fs-7">Total con IVA:</div>
                                                                        <div className="text-end fw-bold fs-6 text-gray-800">$ {totalIva}.00</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tabs.Tab>
                                </Tabs>
                            </div>
                        </div>
                    </>
                ) : (
                        <LoaderC></LoaderC>
                )
            }
        </>
    );
}
